import { css } from '@linaria/atomic';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

const pageStyle = css`
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  min-height: 100%;
  container-type: inline-size;
  opacity: 0;
  animation: fadeIn ease 0.15s;
  animation-fill-mode: forwards;
  display: grid;
  grid-template-areas: 'header' 'content';
  grid-template-rows: auto 1fr;
  grid-template-columns: 100%;
  width: 100%;
  font-size: ${theme.font.size.medium};
  padding: ${theme.spacing(4)};

  @container (max-width: ${breakpoints.xsmall.max}px) {
    padding: ${theme.spacing(3)};
  }
`;

export const PageStyles = {
  pageStyle,
};
